/**
 * @package     Al hirafiyin web app
 * @desc		Page script 
 *
 * @copyright	Copyright (C) 2022 Jaayfer abderrahim, Inc. All rights reserved.
 * @license     see LICENSE.txt
 */
import '../css/contact-us.css';
import app from '../../app';
import $ from 'jquery';
$('head').append($('<script>', {
  type: 'text/javascript',
  src: 'https://www.google.com/recaptcha/api.js?render=' + $('#g-recaptcha').data('public-key')
}));
$('#country-name').parent().on('click', function () {
  const $form = $('#contact-us-form');
  const countries = [];
  const defaultValue = $form.find('[name="country-id"]').val();
  $('#list-countries option').each(function () {
    countries.push({
      id: $(this).val(),
      name: $(this).text(),
      selected: $(this).val() == defaultValue
    });
  });
  app.ui.smartSelect.create({
    el: $('<div>').append($('<select>', {
      id: 'contact-us-country-id',
      name: 'contact-us-country-id'
    }).append(countries.map(function (country) {
      return $('<option>', {
        value: country.id,
        selected: country.selected || undefined
      }).text(country.name);
    }))),
    view: app.ui.view,
    routableModals: false,
    openIn: 'sheet',
    sheetCloseLinkText: app.translate('Close'),
    scrollToSelectedItem: true,
    searchbar: true,
    searchbarDisableButton: false,
    on: {
      open: function (smartSelect) {
        $(smartSelect.el).find('select').off('change');
        $(smartSelect.el).find('select').on('change', function () {
          const countryId = $(this).val();
          // set the country
          $form.find('[name="country-name"]').val($('#list-countries option[value="' + countryId + '"]').text());
          $form.find('[name="country-id"]').val(countryId);
          app.ui.input.checkEmptyState($form.find('[name="country-name"]').get());
          $form.find('[name="city-id"]').val('');
          $form.find('[name="city-name"]').val(app.translate('Loading ..'));
          app.sendHttpRequest({
            url: '/dictionaries/cities?country=' + countryId,
            method: 'get'
          }).then(function (response) {
            $form.find('[name="city-name"]').val('');
            $('#list-cities option[value!=""]').remove();
            for (let p in response) {
              $('#list-cities').append($('<option>', {
                value: p
              }).text(app.translate(response[p].value)));
            }
          }).catch(function (error) {
            console.error(error);
          });
          smartSelect.close();
        });
      },
      close: function () {
        $form.find('[name="country-name"]').trigger('focus');
      }
    }
  }).open();
});
$('#city-name').parent().on('click', function () {
  const $form = $('#contact-us-form');
  const defaultValue = $form.find('[name="city-id"]').val();
  const cities = [];
  $('#list-cities option').each(function () {
    cities.push({
      id: $(this).val(),
      name: $(this).text(),
      selected: $(this).val() == defaultValue
    });
  });
  if (!$('#list-cities option[value!=""]').length) {
    return app.ui.dialog.alert(app.translate("Please select a country !"));
  }
  app.ui.smartSelect.create({
    el: $('<div>').append($('<select>', {
      id: 'contact-us-city-id',
      name: 'contact-us-city-id'
    }).append(cities.map(function (city) {
      return $('<option>', {
        value: city.id,
        selected: city.selected || undefined
      }).text(city.name);
    }))),
    view: app.ui.view,
    routableModals: false,
    openIn: 'sheet',
    sheetCloseLinkText: app.translate('Close'),
    searchbar: true,
    scrollToSelectedItem: true,
    on: {
      open: function (smartSelect) {
        $(smartSelect.el).find('select').off('change');
        $(smartSelect.el).find('select').on('change', function () {
          const cityId = $(this).val();
          // set city
          $form.find('[name="city-name"]').val($('#list-cities option[value="' + cityId + '"]').text());
          $form.find('[name="city-id"]').val(cityId);
          app.ui.input.checkEmptyState($form.find('[name="city-name"]').get());
          smartSelect.close();
        });
      },
      close: function (smartSelect) {
        $form.find('[name="city-name"]').trigger('focus');
      }
    }
  }).open();
});
$('#button-submit').on('click', function (ev) {
  ev.preventDefault();
  grecaptcha.ready(function () {
    grecaptcha.execute($('#g-recaptcha').data('public-key'), {
      action: 'contact_us'
    }).then(function (token) {
      $('#g-recaptcha').val(token);
      $('#contact-us-form').trigger('submit');
    });
  });
});